module.exports = __webpack_public_path__ + "static/media/toggle-on.d74c42ee.svg";